/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_07fcc527"]'><div :class='["modal-header-slot-demo"]'><cube-modal ref="__mpx_ref_modal__" content="我是正文正文" direction="horizontal" confirm-btn="确认继续接单" cancel-btn="取消" :mask-closable="(true)" @confirm='(e)=>__invoke(e, [["onConfirm"]])' @cancel='(e)=>__invoke(e, [["onCancel"]])'><div slot="header"><mpx-image src="https://ut-static.udache.com/webx/mpx-cube-ui/tKQimxwHlkY8nSSqpmGE9_111.jpg" :class='["slot-header"]'></mpx-image></div></cube-modal><cube-button @_click="onTap">modal-header-slot</cube-button></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_07fcc527"}'>
.slot-header
  width 100%
  height 170px
  margin-bottom 20px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_07fcc527"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_07fcc527"}
  /** script content **/
  require("./modal-header-slot.mpx.js?isComponent&outputPath=components%2Fmodal-header-slot07fcc527%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./modal-header-slot.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fmodal-header-slot07fcc527%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_07fcc527"],
    ctorType: "component",
    outputPath: "components/modal-header-slot07fcc527/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/modal/index.mpx?isComponent&outputPath=components%2Findex317b3b4c%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image?isComponent"), {__mpxBuiltIn: true})},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>